import { TAG_TYPES } from 'types/services';
import { heliosApi } from '.';
import type {
  DataTypes,
  GetFormItemsRes,
  GetTemplateFormLayoutRes,
  GlobalSettings,
  LayoutType,
  TemplateDataType,
  TemplateUserDefinedAttributeType,
  UpdateTemplateFormLayoutReq,
} from 'types';

export const heliosFormsService = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getFormLayout: builder.query<GetTemplateFormLayoutRes, { id: string; layoutType: LayoutType }>({
      query: ({ id, layoutType }) => ({
        url: `Forms/${id}/Layouts`,
        method: 'GET',
        params: {
          layoutType,
        },
      }),
      providesTags: [{ type: TAG_TYPES.FORMS, id: 'LAYOUTS' }],
    }),
    updateFormLayout: builder.mutation<void, UpdateTemplateFormLayoutReq & { id: string }>({
      query: ({ id, ...rest }) => ({
        url: `Forms/${id}/Layouts`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: [
        { type: TAG_TYPES.FORMS, id: 'LAYOUTS' },
        { type: TAG_TYPES.FORMS, id: 'ITEMS' },
      ],
    }),
    getFormItems: builder.query<GetFormItemsRes, { id: string; layoutType: LayoutType; showAll?: boolean }>({
      query: ({ id, layoutType, showAll = false }) => ({
        url: `Forms/${id}/ItemLists`,
        method: 'GET',
        params: {
          layoutType,
          showAll,
        },
      }),
      providesTags: [{ type: TAG_TYPES.FORMS, id: 'ITEMS' }],
    }),
    getFormDataTypes: builder.query<DataTypes, { type?: TemplateDataType | TemplateUserDefinedAttributeType }>({
      query: ({ type }) => ({
        url: `Forms/${type}/DataTypes`,
        method: 'GET',
      }),
      providesTags: [{ type: TAG_TYPES.FORMS, id: 'LAYOUTS' }],
    }),
    getFormGlobalSettings: builder.query<GlobalSettings, { id: string }>({
      query: ({ id }) => ({
        url: `Forms/${id}/GlobalSettings`,
        method: 'GET',
      }),
      providesTags: [{ type: TAG_TYPES.FORMS, id: 'LAYOUTS' }],
    }),
    updateFormGlobalSettings: builder.mutation<void, Omit<GlobalSettings & { id: string }, 'hasMobileLayout' | 'hasWebLayout'>>({
      query: ({ id, ...rest }) => ({
        url: `Forms/${id}/GlobalSettings`,
        method: 'PATCH',
        body: rest,
      }),
      invalidatesTags: [{ type: TAG_TYPES.FORMS, id: 'LAYOUTS' }],
    }),
  }),
});
export const {
  useGetFormLayoutQuery,
  useUpdateFormLayoutMutation,
  useGetFormItemsQuery,
  useGetFormGlobalSettingsQuery,
  useUpdateFormGlobalSettingsMutation,
  useGetFormDataTypesQuery,
} = heliosFormsService;
